import { STRONG_PASSWORD_REGEX } from './_constants/strong-password.regex';
import { ISO_DATE_REGEX } from './_constants/iso_date.regex';
import { LATITUDE_REGEX } from './_constants/latitude-regex.const';
import { LONGITUDE_REGEX } from './_constants/longitude-regex.const';
import { PHONE_NUMBER_REGEX } from './_constants/phone-number-regex.const';
import { URL_REGEX } from './_constants/url-regex.const';
import { ZIP_CODE_REGEX } from './_constants/zip-code-regex.const';

/**
 * A regular expression utility
 */
export class RegexUtil {
  /**
   * Determine if the passed string is an ISO date
   * @param text - The text to test
   * @returns True if the passed text is an ISO date
   */
  public static isIsoDate(text: string): boolean {
    if (ISO_DATE_REGEX.test(text) === true) {
      return true;
    }
    return false;
  }

  /**
   * Determine if the passed string is a latitude
   * @param text - The text to test
   * @returns True if the passed text is a latitude
   */
  public static isLatitude(text: string): boolean {
    if (LATITUDE_REGEX.test(text) === true) {
      return true;
    }
    return false;
  }

  /**
   * Determine if the passed string is a longitude
   * @param text - The text to test
   * @returns True if the passed text is a longitude
   */
  public static isLongitude(text: string): boolean {
    if (LONGITUDE_REGEX.test(text) === true) {
      return true;
    }
    return false;
  }

  /**
   * Determine if the passed string is a phone number
   * @param text - The text to test
   * @returns True if the passed text is a phone number
   */
  public static isPhoneNumber(text: string): boolean {
    if (PHONE_NUMBER_REGEX.test(text) === true) {
      return true;
    }
    return false;
  }

  /**
   * Determine if the passed string is a strong password
   * @param text - The text to test
   * @returns True if the passed text is a strong password
   */
  public static isStrongPassword(text: string): boolean {
    if (STRONG_PASSWORD_REGEX.test(text) === true) {
      return true;
    }
    return false;
  }

  /**
   * Determine if the passed text is a URL
   * @param text - The text to test
   * @returns True if the passed text is a URL
   */
  public static isUrl(text: string): boolean {
    if (URL_REGEX.test(text) === true) {
      return true;
    }
    return false;
  }

  /**
   * Determine if the passed text is a zip code
   * @param text - The text to test
   * @returns True if the passed text is a zip code
   */
  public static isZipCode(text: string): boolean {
    if (ZIP_CODE_REGEX.test(text) === true) {
      return true;
    }
    return false;
  }
}
